var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _circle3, _circle4, _ellipse, _circle5, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.241,
    height: 58.015,
    viewBox: "0 0 274.241 58.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.003 -30.678)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.003 30.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.138 9.251)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6,57.372a10.79,10.79,0,0,0-15.411,5.75L64.088,62a14.084,14.084,0,0,0-.8,5.568l3.252-.2a10.91,10.91,0,0,0,2.554,6.361L66.6,75.86a14.036,14.036,0,0,0,8.622,4.822,13.725,13.725,0,0,0,4.148.008L78.9,77.415a10.74,10.74,0,0,0,7.567-4.933l2.808,1.761a14.029,14.029,0,0,0,1.769-4.235l-3.2-.761a10.943,10.943,0,0,0,.016-4.941l3.212-.746a14.077,14.077,0,0,0-1.293-3.434,13.9,13.9,0,0,0-1.5-2.253L85.7,59.957a10.814,10.814,0,0,0-3.1-2.61Z",
    transform: "translate(-52.421 -42.849)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5,67.355a18.2,18.2,0,0,0-1.38-8.527l2.11-.888c-.246-.579-.516-1.15-.817-1.713a20.915,20.915,0,0,0-6.48-7.273L90.648,50.81A18.786,18.786,0,0,0,88.4,49.477c-.048-.024-.1-.048-.151-.071l-.468.96c.293.143.579.293.865.452a17.348,17.348,0,0,1,5,4.2L91.1,57.083a13.9,13.9,0,0,1,1.5,2.253,14.077,14.077,0,0,1,1.293,3.434l3.2-.746a17.466,17.466,0,0,1-.024,7.947l-3.2-.761A14.113,14.113,0,0,1,92.1,73.446l2.768,1.737c-.293.468-.611.92-.944,1.356l2.625,2.023a21.11,21.11,0,0,0,2.181-3.514l-2.046-1a18.266,18.266,0,0,0,1.808-6.694Z",
    transform: "translate(-55.249 -42.037)",
    fill: "#42afd2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.522,80.482a14.257,14.257,0,0,1-4.148-.008,14.036,14.036,0,0,1-8.622-4.822L63.23,77.8a17.452,17.452,0,0,1-4.117-10.24l3.323-.2a14.084,14.084,0,0,1,.8-5.568l-3.093-1.118a18.089,18.089,0,0,1,1.2-2.617,17.062,17.062,0,0,1,2.34-3.244l-.777-.706A18.388,18.388,0,0,0,58.13,65.062l-2.237-.174a20.637,20.637,0,0,0,3.315,12.976l1.816-1.19A18.391,18.391,0,0,0,74.144,84.86l-.278,2.2a20.73,20.73,0,0,0,13.285-2.792l-1.705-2.84A17.256,17.256,0,0,1,79,83.726Z",
    transform: "translate(-51.563 -42.632)",
    fill: "#4eaf52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.318,76.411,88.511,74.65a10.741,10.741,0,0,1-7.567,4.933l.476,3.276A14.11,14.11,0,0,0,86.647,81L88.336,83.8a17.457,17.457,0,0,0,4.807-4.291l-2.594-2a12.977,12.977,0,0,0,.761-1.1Z",
    transform: "translate(-54.46 -45.001)",
    fill: "#fbb03f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.572,76.64c-.238.381-.492.746-.761,1.1l2.594,2c.333-.436.65-.888.944-1.356L92.58,76.648Z",
    transform: "translate(-55.714 -45.231)",
    fill: "#4888c7",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.482,83.677l.476,3.244a17.306,17.306,0,0,0,6.448-2.3l-1.689-2.808a14.11,14.11,0,0,1-5.227,1.864Z",
    transform: "translate(-54.522 -45.828)",
    fill: "#4a906a",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.048,70.251l3.2.761c.087-.373.167-.754.222-1.134a14.185,14.185,0,0,0-.2-5.306l-3.212.746a10.832,10.832,0,0,1-.016,4.941Z",
    transform: "translate(-55.626 -43.839)",
    fill: "#4eaf52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.67,70.915l3.2.761a17.466,17.466,0,0,0,.024-7.947l-3.2.746a13.862,13.862,0,0,1,.2,5.306c-.056.381-.135.761-.222,1.134Z",
    transform: "translate(-56.043 -43.742)",
    fill: "#329f48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.551,68.867l-3.252.2a14.088,14.088,0,0,0,3.315,8.289L69.1,75.228A10.838,10.838,0,0,1,66.551,68.867Z",
    transform: "translate(-52.425 -44.334)",
    fill: "#f37820"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.857,69.091l-3.323.2a17.5,17.5,0,0,0,4.117,10.24l2.522-2.149A14.088,14.088,0,0,1,62.857,69.091Z",
    transform: "translate(-51.99 -44.36)",
    fill: "#b56869"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2,61.158l3.1,1.118a10.783,10.783,0,0,1,18.512-3.141l2.57-2.086a14.106,14.106,0,0,0-4.751-3.783l1.436-2.935a17.091,17.091,0,0,0-6.734-1.745L78.1,51.878a10.3,10.3,0,0,0-2.094.071l-.452-3.276A17.4,17.4,0,0,0,64.649,54.2l2.427,2.229a14.026,14.026,0,0,0-2.863,4.751Z",
    transform: "translate(-52.529 -41.995)",
    fill: "#fbb03f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.922,57.268l2.546-2.062a17.243,17.243,0,0,0-5-4.2c-.286-.159-.571-.309-.865-.452l-1.436,2.935A14.2,14.2,0,0,1,90.922,57.268Z",
    transform: "translate(-55.063 -42.221)",
    fill: "#4888c7",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,60.768l3.093,1.118a14.026,14.026,0,0,1,2.863-4.751l-2.427-2.229a17.787,17.787,0,0,0-2.34,3.244,18.089,18.089,0,0,0-1.2,2.617Z",
    transform: "translate(-52.124 -42.724)",
    fill: "#0f9f58",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.16,80.962l-3.688,2.419A24.978,24.978,0,0,0,72.644,94.406c.206.032.42.063.627.087l.547-4.339c-.159-.024-.317-.04-.484-.063A20.644,20.644,0,0,1,59.152,80.97Z",
    transform: "translate(-51.522 -45.729)",
    fill: "#42afd2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.466,79.616l-1.816,1.19a20.6,20.6,0,0,0,14.182,9.121c.159.024.317.048.484.063l.278-2.2a18.431,18.431,0,0,1-13.119-8.185Z",
    transform: "translate(-52.004 -45.573)",
    fill: "#329f48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5,68.809a25.1,25.1,0,0,0-1.872-11.58l-3.966,1.666A20.676,20.676,0,0,1,100.175,76l3.871,1.9a24.872,24.872,0,0,0,2.459-9.082Z",
    transform: "translate(-56.678 -42.992)",
    fill: "#fbb03f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.391,59.112,98.282,60a18.2,18.2,0,0,1,1.38,8.526,18.423,18.423,0,0,1-1.808,6.694l2.046,1a20.749,20.749,0,0,0,1.872-5.98,20.5,20.5,0,0,0-1.38-11.128Z",
    transform: "translate(-56.411 -43.209)",
    fill: "#4888c7",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.691,51.409l1.658,1.515a18.243,18.243,0,0,1,4.22-3.426l-3.363-5.663a25.049,25.049,0,0,0-12.2,19.528l4.331.341c.04-.484.1-.96.167-1.444a20.583,20.583,0,0,1,5.187-10.85Z",
    transform: "translate(-51.007 -41.447)",
    fill: "#f37820"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9,53.911,61.247,52.4a20.527,20.527,0,0,0-5.187,10.85c-.071.484-.127.968-.167,1.444l2.237.174A18.388,18.388,0,0,1,62.9,53.911Z",
    transform: "translate(-51.57 -42.434)",
    fill: "#b56869"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.652,48.06,94.127,44.5a25.348,25.348,0,0,0-3.038-1.808,24.4,24.4,0,0,0-3.847-1.555l-1.959,6.29A19.977,19.977,0,0,1,87.972,48.5l.991-2.03a20.889,20.889,0,0,1,2.7,1.586Z",
    transform: "translate(-54.961 -41.135)",
    fill: "#4eaf52"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.708,50.6l1.285-1.856a20.888,20.888,0,0,0-2.7-1.586l-.991,2.03c.048.024.1.048.151.071A18.178,18.178,0,0,1,90.7,50.595Z",
    transform: "translate(-55.309 -41.83)",
    fill: "#329f48"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.989,44.86a16.437,16.437,0,0,0-3.474.119l.452,3.244a17.3,17.3,0,0,1,2.792-.087L80,44.86Z",
    transform: "translate(-53.949 -41.56)",
    fill: "#42afd2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.571,51.857l.238-3.292a17.323,17.323,0,0,0-2.792.087l.452,3.276a10.3,10.3,0,0,1,2.094-.071Z",
    transform: "translate(-54.007 -41.99)",
    fill: "#4888c7",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.204,
    cy: 3.204,
    r: 3.204,
    transform: "translate(58.533 13.391)",
    fill: "#f37820"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.88,
    cy: 1.88,
    r: 1.88,
    transform: "translate(66.044 10.155)",
    fill: "#f37820"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.229,
    cy: 2.229,
    r: 2.229,
    transform: "translate(54.474 48.215) rotate(-6.56)",
    fill: "#42afd2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.309,
    cy: 1.309,
    r: 1.309,
    transform: "translate(59.207 52.865) rotate(-6.56)",
    fill: "#42afd2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.061,
    cy: 4.053,
    rx: 4.061,
    ry: 4.053,
    transform: "matrix(0.855, -0.519, 0.519, 0.855, 0, 14.46)",
    fill: "#4eaf52"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.379,
    cy: 2.379,
    r: 2.379,
    transform: "matrix(0.855, -0.519, 0.519, 0.855, 10.25, 18.402)",
    fill: "#4eaf52"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9,30.816a3.049,3.049,0,0,0-2.4,5.568c.008,0,.024.016.032.016a4.453,4.453,0,0,1,2.427,2.689,3.914,3.914,0,0,1-.563,2.768.26.26,0,0,1-.032.151l-.079.119a.916.916,0,0,0-.135.262,1.914,1.914,0,1,0,2.935-.968.248.248,0,0,1-.071-.087c-1.451-1.1-2.76-2.744-.611-5.727a.37.37,0,0,1,.04-.079,2.963,2.963,0,0,0,.476-.912A3.049,3.049,0,0,0,69.91,30.8Z",
    transform: "translate(-36.591 -30.678)",
    fill: "#42afd2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 36.408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.86,74.334l-1.967,5.457a2.9,2.9,0,0,1-1.586,1.253,2.8,2.8,0,0,1-2.276-.278,2.231,2.231,0,0,0-3.292.817c0,.016-.024.024-.032.032a.19.19,0,0,1,.024-.056l2.054-4.148c.032-.056.056-.111.079-.159l.04-.079a3.328,3.328,0,0,1,1.705-1.539,2.873,2.873,0,0,1,2.03.151A2.014,2.014,0,0,0,43,75.555a4.946,4.946,0,0,0,.857-1.237Z",
    transform: "translate(-30.546 -72.12)",
    fill: "#fbb03f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.164,82.018l.024-.056,2.054-4.148a4.912,4.912,0,0,1-.341.484,2.2,2.2,0,0,1-2.7.523,2.2,2.2,0,0,0-1.626-.119,2.25,2.25,0,0,0,1.356,4.291,2.327,2.327,0,0,0,1.237-.976Z",
    transform: "translate(-30.003 -72.523)",
    fill: "#fbb03f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.786,74.46a3.754,3.754,0,0,0-4.711-2.451,3.8,3.8,0,0,0-2.284,2.015h0v.016L42.839,79.5A1.97,1.97,0,0,1,44.9,78.3a5.327,5.327,0,0,1,1.412.508,3.743,3.743,0,0,0,5.481-4.354Z",
    transform: "translate(-31.484 -71.833)",
    fill: "#fbb03f"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.68,43.5a.56.56,0,0,1,.635-.635H131.3a9.4,9.4,0,0,1,3.189.523,7.323,7.323,0,0,1,2.53,1.515,6.923,6.923,0,0,1,1.666,2.4,8.861,8.861,0,0,1,0,6.425,6.872,6.872,0,0,1-1.666,2.419,7.628,7.628,0,0,1-2.53,1.539,9.033,9.033,0,0,1-3.189.547H124.29V68.461a.56.56,0,0,1-.635.635h-.341a.56.56,0,0,1-.635-.635V43.5Zm8.542,13.23a6.515,6.515,0,0,0,4.632-1.634A5.967,5.967,0,0,0,137.6,50.5a5.842,5.842,0,0,0-1.745-4.553,6.587,6.587,0,0,0-4.632-1.594H124.29V56.73Z",
    transform: "translate(-40.694 -32.084)",
    fill: "#636464"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.77,43.389a.675.675,0,0,1,.714-.523h.674a.675.675,0,0,1,.714.523l9.367,24.961c.174.5,0,.754-.523.754H166.3a.668.668,0,0,1-.714-.484l-3.22-8.582H151.233l-3.189,8.55a.675.675,0,0,1-.714.523h-.412c-.523,0-.7-.246-.523-.754L155.762,43.4Zm6.036,15.141-3.974-10.644a6.923,6.923,0,0,1-.341-.952c-.1-.365-.2-.706-.3-1.031-.1-.373-.214-.761-.341-1.166h-.071c-.127.4-.238.785-.341,1.166-.1.325-.206.666-.317,1.031s-.222.682-.317.952l-4.013,10.644H161.8Z",
    transform: "translate(-43.422 -32.084)",
    fill: "#636464"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.541,43.5a.56.56,0,0,1,.635-.635h.341a.56.56,0,0,1,.635.635V67.6h11.882a.563.563,0,0,1,.635.635v.222a.56.56,0,0,1-.635.635H180.176a.56.56,0,0,1-.635-.635Z",
    transform: "translate(-47.253 -32.084)",
    fill: "#636464"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.426,43.469a.6.6,0,0,1,.635-.6h.452a.785.785,0,0,1,.754.484l7.424,16.006c.151.325.3.666.452,1.015s.286.666.412.936c.127.349.262.69.412,1.015h.071c.127-.325.262-.658.412-1.015.127-.278.262-.587.412-.936s.3-.69.452-1.015L224.74,43.35a.766.766,0,0,1,.754-.484h.452a.59.59,0,0,1,.635.6L228.6,68.429c0,.452-.214.674-.635.674h-.341a.59.59,0,0,1-.635-.6l-1.57-19.417a10.472,10.472,0,0,1-.1-1.087c-.016-.4-.016-.777-.016-1.126V45.594h-.071c-.151.428-.3.849-.452,1.277-.127.349-.27.722-.428,1.126s-.317.761-.468,1.087L217.07,63.551a.766.766,0,0,1-.754.484h-.6a.773.773,0,0,1-.753-.484l-6.782-14.467c-.151-.3-.309-.658-.468-1.071s-.309-.809-.428-1.182c-.151-.452-.309-.888-.484-1.309h-.071v1.309c0,.373-.016.761-.04,1.166s-.048.761-.071,1.087L205.045,68.5a.6.6,0,0,1-.635.6h-.341c-.428,0-.635-.222-.635-.674l2.023-24.961Z",
    transform: "translate(-50.009 -32.084)",
    fill: "#636464"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M241.782,55.744a13.546,13.546,0,0,1,1.015-5.267,12.837,12.837,0,0,1,7.012-7.083,13.885,13.885,0,0,1,10.5,0,12.837,12.837,0,0,1,7.012,7.083,13.692,13.692,0,0,1,1.015,5.267,14.56,14.56,0,0,1-1.015,5.4,13.651,13.651,0,0,1-2.792,4.37,13.076,13.076,0,0,1-4.22,2.927,13.409,13.409,0,0,1-10.5,0,13.077,13.077,0,0,1-4.22-2.927,13.433,13.433,0,0,1-2.792-4.37A14.321,14.321,0,0,1,241.782,55.744Zm1.689,0a13.071,13.071,0,0,0,.88,4.83,12.276,12.276,0,0,0,2.419,3.894,11.026,11.026,0,0,0,3.672,2.594,11.323,11.323,0,0,0,4.608.944,11.168,11.168,0,0,0,4.608-.944,10.947,10.947,0,0,0,3.672-2.594,12.276,12.276,0,0,0,2.419-3.894,13.07,13.07,0,0,0,.88-4.83,12.222,12.222,0,0,0-.88-4.7,11.721,11.721,0,0,0-2.419-3.775,11.01,11.01,0,0,0-3.672-2.5,12.2,12.2,0,0,0-9.217,0,10.931,10.931,0,0,0-3.672,2.5,11.721,11.721,0,0,0-2.419,3.775,12.426,12.426,0,0,0-.88,4.7Z",
    transform: "translate(-54.432 -32.026)",
    fill: "#636464"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M282.791,43.5a.56.56,0,0,1,.635-.635h.373a.917.917,0,0,1,.785.412l14.658,20.162c.2.3.428.635.69,1.015s.492.738.69,1.087c.246.4.5.8.754,1.2h.071c-.048-.373-.087-.761-.111-1.166-.024-.349-.048-.706-.056-1.071s-.016-.714-.016-1.071V43.491a.56.56,0,0,1,.635-.635h.341a.56.56,0,0,1,.635.635V68.452a.56.56,0,0,1-.635.635h-.373a.917.917,0,0,1-.785-.412L286.424,48.512c-.222-.3-.46-.635-.714-1.015s-.476-.738-.674-1.087c-.254-.4-.5-.8-.754-1.2h-.071q.036.559.071,1.166c.024.349.048.714.071,1.087s.04.722.04,1.047v19.94a.56.56,0,0,1-.634.635h-.341a.56.56,0,0,1-.635-.635V43.491Z",
    transform: "translate(-59.162 -32.083)",
    fill: "#636464"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M324.445,43.389a.675.675,0,0,1,.714-.523h.674a.675.675,0,0,1,.714.523l9.367,24.961c.174.5,0,.754-.523.754h-.412a.668.668,0,0,1-.714-.484l-3.22-8.582H319.908l-3.188,8.55a.675.675,0,0,1-.714.523h-.412c-.523,0-.7-.246-.523-.754L324.437,43.4Zm6.036,15.141-3.974-10.644a6.927,6.927,0,0,1-.341-.952c-.1-.365-.2-.706-.3-1.031-.1-.373-.214-.761-.341-1.166h-.071c-.127.4-.238.785-.341,1.166-.1.325-.206.666-.317,1.031s-.222.682-.317.952l-4.013,10.644h10.01Z",
    transform: "translate(-62.879 -32.084)",
    fill: "#636464"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.86 45.586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.407,82.369h3.117a2.471,2.471,0,0,1,2.57,2.625,2.5,2.5,0,0,1-2.57,2.657h-1.65v2.784h-1.467V82.369Zm2.84,4.013a1.275,1.275,0,0,0,1.356-1.388,1.246,1.246,0,0,0-1.333-1.364h-1.4v2.752h1.372Z",
    transform: "translate(-121.407 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,88.366H139.07l-.682,2.07h-1.515l2.84-8.066h1.531l2.84,8.066h-1.515l-.682-2.07Zm-1.42-4.6s-.182.793-.341,1.253l-.714,2.157h2.118l-.714-2.157c-.151-.452-.317-1.253-.317-1.253h-.024Z",
    transform: "translate(-123.191 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.216,83.63h-2.649V82.369h6.766V83.63h-2.649v6.805h-1.467Z",
    transform: "translate(-125.116 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.418,82.369h1.467v3.419h3.7V82.369h1.467v8.066h-1.467V87.049h-3.7v3.387h-1.467Z",
    transform: "translate(-127.176 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.764,82.217a4.076,4.076,0,0,1,4.172,4.117,4.172,4.172,0,1,1-8.344,0A4.038,4.038,0,0,1,193.764,82.217Zm0,7a2.735,2.735,0,0,0,2.657-2.887,2.638,2.638,0,0,0-2.657-2.776,2.676,2.676,0,0,0-2.657,2.776A2.774,2.774,0,0,0,193.764,89.221Z",
    transform: "translate(-129.272 -82.209)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.237,82.217a4.393,4.393,0,0,1,3,1.023l-.73,1.095a3.489,3.489,0,0,0-2.149-.769,2.621,2.621,0,0,0-2.776,2.776,2.693,2.693,0,0,0,2.7,2.887,3.044,3.044,0,0,0,2.023-.841v-.944H214.07V86.183h2.554v4.251H215.37v-.389c0-.167.008-.341.008-.341h-.024a3.417,3.417,0,0,1-2.34.865,3.974,3.974,0,0,1-3.958-4.18,4.067,4.067,0,0,1,4.156-4.156Z",
    transform: "translate(-131.517 -82.209)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.459,82.369h4.83V83.63h-3.363v2.118h2.721v1.261h-2.721v2.173h3.545v1.261h-5.013V82.377Z",
    transform: "translate(-133.755 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.849,82.369h1.467l3.062,4.664a12.169,12.169,0,0,1,.674,1.253h.024S250,87.517,250,87.033V82.369h1.451v8.066H250l-3.054-4.648a12.168,12.168,0,0,1-.674-1.253h-.024s.079.769.079,1.253v4.648h-1.467V82.369Z",
    transform: "translate(-135.646 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.15,82.217a4.076,4.076,0,0,1,4.172,4.117,4.172,4.172,0,1,1-8.344,0A4.038,4.038,0,0,1,267.15,82.217Zm0,7a2.735,2.735,0,0,0,2.657-2.887,2.638,2.638,0,0,0-2.657-2.776,2.676,2.676,0,0,0-2.657,2.776A2.774,2.774,0,0,0,267.15,89.221Z",
    transform: "translate(-137.737 -82.209)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.461,82.369h1.57l1.578,3.99c.182.476.412,1.182.412,1.182h.024s.214-.706.4-1.182l1.578-3.99h1.57l.65,8.066h-1.451l-.341-4.513c-.032-.531-.008-1.253-.008-1.253h-.024s-.238.785-.428,1.253l-1.309,3.125H286.4L285.1,85.923c-.19-.468-.444-1.261-.444-1.261h-.024s.024.73-.008,1.261l-.341,4.513h-1.467l.658-8.066Z",
    transform: "translate(-140.026 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.36,82.369h1.467v8.066H303.36Z",
    transform: "translate(-142.395 -82.227)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.843,82.217a4.159,4.159,0,0,1,2.974,1.1l-.706,1.095a3.563,3.563,0,0,0-2.205-.849,2.628,2.628,0,0,0-2.7,2.776,2.74,2.74,0,0,0,2.713,2.887,3.476,3.476,0,0,0,2.34-1.023l.769,1.055a4.333,4.333,0,0,1-3.173,1.309,4.172,4.172,0,0,1-.024-8.344Z",
    transform: "translate(-143.816 -82.209)",
    fill: "#636464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,88.347a3.232,3.232,0,0,0,2.015.849c.611,0,1.174-.317,1.174-.976,0-1.444-3.807-1.19-3.807-3.672a2.479,2.479,0,0,1,2.7-2.34,3.568,3.568,0,0,1,2.411.865l-.635,1.19a2.932,2.932,0,0,0-1.785-.706c-.682,0-1.214.4-1.214.968,0,1.436,3.8,1.079,3.8,3.656a2.409,2.409,0,0,1-2.657,2.364,3.913,3.913,0,0,1-2.784-1.1l.793-1.1Z",
    transform: "translate(-145.913 -82.208)",
    fill: "#636464"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be4762ebaa3fd32225f011c7d4a6a56a.svg";
export { ForwardRef as ReactComponent };